var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("h3", { class: ["h-label", _vm.border ? "" : "border-0"] }, [
    _c(
      "span",
      { staticClass: "upper" },
      [
        _vm._t("upper", function () {
          return [_vm._v(_vm._s(_vm.upper))]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.lower || _vm.$slots.lower
      ? _c(
          "span",
          { class: "lower size-" + _vm.size },
          [
            _vm._t("lower", function () {
              return [_vm._v(_vm._s(_vm.lower))]
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }